"use strict";

/* =========================
   Debug 設定
========================= */
const DEBUG = false; // ← 本番では false / 開発時だけ true

function log(...args) {
  if (!DEBUG) return;
  console.log(...args);
}

function warn(...args) {
  if (!DEBUG) return;
  console.warn(...args);
}

function errorLog(...args) {
  if (!DEBUG) return;
  console.error(...args);
}

/* =========================
   c_fv Animation
========================= */
function initCFvAnimation() {
  log('=== c_fv Animation Debug ===');

  const image = document.querySelector('.c_fv__img img');
  const textLines = document.querySelectorAll('.c_fv__text--style');

  log('Found image:', image);
  log('Found textLines:', textLines.length);
  log('GSAP available:', !!window.gsap);

  if (!image && textLines.length === 0) {
    warn('No elements found for animation');
    return;
  }

  try {
    const gsap = window.gsap;
    if (!gsap) {
      warn('GSAP not loaded');
      return;
    }

    const tl = gsap.timeline();

const isMobile = window.innerWidth <= 989;

// SPはpxで少しだけずらす
const startX = isMobile ? -30 : '-16%';
const duration = isMobile ? 15.0 : 30.0;

/* 画像アニメーション */
if (image) {
  tl.fromTo(
    image,
    { x: startX, opacity: 1 },
    { x: 0, opacity: 1, duration, ease: 'power2.out' }
  );
}

    /* テキストを span に分割 */
    const splitTargets = document.querySelectorAll('.c_fv__text--style');
    splitTargets.forEach((target) => {
      if (!target.classList.contains('is-active')) {
        const text = target.textContent || '';
        target.innerHTML = '';
        text.split('').forEach((char) => {
          target.insertAdjacentHTML('beforeend', `<span>${char}</span>`);
        });
        target.classList.add('is-active');
      }
    });

    /* テキストアニメーション */
    const textEffects = document.querySelectorAll('.c_fv__text--style');
    textEffects.forEach((target, lineIndex) => {
      const spans = target.querySelectorAll('span');

      // 文字
      tl.fromTo(
        spans,
        { opacity: 0, y: '20px' },
        {
          opacity: 1,
          y: '0px',
          duration: 1.5,
          stagger: 0.1,
          ease: 'power2.out'
        },
        0.3 + lineIndex * 0.8
      );

      // 下線
      tl.fromTo(
        target,
        { '--scaleX': 0, opacity: 0 },
        { '--scaleX': 1, opacity: 1, duration: 1.8, ease: 'power2.out' },
        0.3 + lineIndex * 0.8
      );
    });

    log('Animation started successfully');
  } catch (e) {
    errorLog('Animation error:', e);
  }
}

/* =========================
   Init
========================= */
document.addEventListener('DOMContentLoaded', initCFvAnimation);
